

function ArrowLeft() {
    return (
      <div className="
      translate-x-[4px] 
      group-hover:opacity-100 group-hover:translate-x-[1px] group-hover:translate-y-0 
      transition-all duration-300 ease-out">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-narrow-left"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M5 12l14 0" /><path d="M5 12l4 4" /><path d="M5 12l4 -4" /></svg>
      </div>
    )
  }
  
  export default ArrowLeft;